<template>
  <el-dialog
    title="图片预览"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-carousel :interval="5000" :arrow="pictureList.length == 1 ? 'never' : 'always'" height="540px" :autoplay="false">
        <el-carousel-item v-for="(img, index) in pictureList" :key="index">
          <img :src="img" alt="图片" style="width: 100%; height: 100%; object-fit: contain;">
        </el-carousel-item>
      </el-carousel>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <!-- <el-button type="primary" @click="addOrUpdateFun">保 存</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
import { reportTaskback } from "@/api/task.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    pictureList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 0px 0px;
}

/deep/.el-input {
  width: auto !important;
}
/deep/.el-dialog {
  margin-top: 10vh !important;
}
.flex {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/reportproblemAnalysis/components/pictureDialog.vue